import React from "react";
import Header from "./Header";

export default ({ children }) => {
  return (
    <main className="drawer-content">
      <div className="grid grid-cols-12 grid-rows-[min-content] gap-y-12 p-4 lg:gap-x-12 lg:p-10  sticky top-0 z-10 bg-base-200 shadow-2xl">
        <Header />
      </div>
      <div className="p-4 lg:p-10">{children}</div>
    </main>
  );
};
